import React, {useState} from 'react';

type WithoutMouseEvents<T> = Omit<T, 'hover' | 'onMouseEnter' | 'onMouseLeave'>;

export default function withMouseOver<Props>(
  WrappedComponent: React.ComponentType<Props>,
): React.ForwardRefExoticComponent<
  React.PropsWithoutRef<WithoutMouseEvents<Props>> &
    React.RefAttributes<unknown>
> {
  return React.forwardRef<unknown, WithoutMouseEvents<Props>>((props, ref) => {
    const [hover, setHover] = useState(false);
    const onMouseEnter = () => setHover(true);
    const onMouseLeave = () => setHover(false);

    return (
      <WrappedComponent
        ref={ref}
        {...(props as Props)}
        hover={hover}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    );
  });
}
